import { ChangeDetectionStrategy, Component, input } from '@angular/core';
import { Event } from '../../models';
import { ImageComponent } from '@teamfoster/sdk/image';
import { YoutubeComponent } from 'src/app/standalone/components/youtube/youtube.component';
import { CookiePreferences } from '@teamfoster/sdk/cookie-ngrx';
import { RouterLink } from '@angular/router';
import { EventDatePipe } from '../../pipes/event-date.pipe';
import { IconComponent } from '@teamfoster/sdk/icon';
import { DatePipe } from '@angular/common';
@Component({
    selector: 'app-featured-event-card',
    imports: [ImageComponent, YoutubeComponent, RouterLink, EventDatePipe, IconComponent, DatePipe],
    templateUrl: './featured-event-card.component.html',
    styleUrl: './featured-event-card.component.scss',
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class FeaturedEventCardComponent {
  event = input.required<Event>();
  cookiePreferences = input<CookiePreferences>();
}
